import { Link } from "react-router-dom";
import { PassageChecker } from "../components/PassageChecker.js";
import * as s from "../styles.js";

export function CheckPage(): JSX.Element {
  return (
    <div style={{ ...s.wide, maxWidth: 920 }}>
      <h1 style={{ ...s.heading1, fontSize: 34 }}>Check a passage</h1>
      <hr style={s.goldRule} />
      <p style={{ ...s.lead, maxWidth: 760 }}>
        Paste text from anywhere — a lesson plan, a news article, a parenting post, a professional-development handout.
        EduFadder points out any well-known education ideas in it and what research says about them. No account needed;
        the text is checked in memory and never stored. With the <Link to="/get-extension">browser extension</Link>, this
        happens automatically as you read.
      </p>
      <div style={{ ...s.card, marginTop: 24 }}>
        <PassageChecker />
      </div>
    </div>
  );
}
